import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';

type ListCardProps = {
  readonly children: ReactNode;
  readonly className?: string;
};

export function ListCard({ children, className }: ListCardProps) {
  return (
    <div className={cn('divide-y overflow-hidden rounded-xl border bg-card', className)}>{children}</div>
  );
}
